// extracted by css-extract-rspack-plugin
var _1 = "AgAjxa_FJ3g0GkdV";
var _2 = "xxL1XkZyC8wrdHab";
var _3 = "nIsd5KxAaYuHoKVW";
var _4 = "xFx2jvLkkRsoyER3";
var _5 = "xFx2jvLkkRsoyER3";
var _6 = "WAurP8CDYfc_XzvS";
export { _1 as "date", _2 as "description", _3 as "details", _4 as "empty-message", _5 as "emptyMessage", _6 as "title" }
